import { Grid, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { InfoBox } from "../../../components/info-box/info-box";
import { InvoiceAddressMarker } from "../../../components/Primitives/Icons";
import { useScreenSize } from "../../../hooks/use-screen-size";
import { useAddressIconStyle } from "../../../style/address-icon.style";
import { getAddressBaseTextParts } from "../../../utils/address.util";
import { TEXT_SEPARATOR } from "../../../utils/constants";
import { DetailValueDisplay } from "../../../components/value-display/detail-value-display.component";
import { IAddress } from "../../../domain/group/address";
import { IGroup } from "../../../domain/group/group";
import { GroupDetailName } from "./group-detail-name.component";
import { VFC } from "react";

const useStyles = makeStyles()(() => ({
  dataContainer: {
    marginTop: 15,
  },
  invoiceAddressContainer: {
    marginTop: 5,
  },
  groupAddressContainer: {
    marginTop: 15,
  },
  boldText: {
    fontWeight: "bold",
  },
  textAlign: {
    textAlign: "center",
  },
}));

interface IGroupDetailBaseInfoProps {
  group: IGroup;
  headerOnly?: boolean;
}

export const GroupDetailBaseInfo: VFC<IGroupDetailBaseInfoProps> = (props) => {
  const { group, headerOnly } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { isMobile } = useScreenSize();
  const { classes: addressIconClasses } = useAddressIconStyle();

  const getAddressText = (address: IAddress) => {
    let textParts: string[] = [];
    if (address.name) {
      textParts.push(`${address.name}`);
    }
    textParts = textParts.concat(getAddressBaseTextParts(address, t));
    return textParts.join(`${TEXT_SEPARATOR} `);
  };

  const getAddressTextComponent = (address: IAddress) => {
    const description = t("basedata.addresses.type.invoice")
    return (
      <Grid container direction="column">
        <Grid item>
          <Typography
            variant="body1"
            className={classNames(classes.boldText, {
              [classes.textAlign]: isMobile,
            })}
          >
            {description}:
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            variant="body1"
            className={classNames({
              [classes.textAlign]: isMobile,
            })}
          >
            {getAddressText(address)}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  return (
    <>

      <Grid container direction="column">
        <Grid item>
          <GroupDetailName
            name={group.name}
            active={group.active ?? null}
          />
        </Grid>
        {!headerOnly && (
          <Grid item className={classes.dataContainer}>
            <Grid container direction="row">
              <Grid item xs={12} md={6}>
                <DetailValueDisplay label={t("basedata.groups.edit.erpNumber")} value={group.erpNumber} />
              </Grid>
              <Grid item xs={12} md={6}>
                <DetailValueDisplay label={t("basedata.groups.edit.vatId")} value={group.vatId ?? "-"} />
              </Grid>
              <Grid item xs={12} md={6}>
                <DetailValueDisplay
                  label={t("basedata.groups.edit.tradeRegisterNumber")}
                  value={group.tradeRegisterNumber ?? "-"}
                />
              </Grid>
              {group.invoiceAddress && (
                <Grid item xs={12} className={classes.invoiceAddressContainer}>
                  <InfoBox
                    iconComponent={
                      <InvoiceAddressMarker
                        className={addressIconClasses.groupOrInvoiceAddressIcon}
                        viewBox="0 0 28 40"
                      />
                    }
                    labelComponent={getAddressTextComponent(group.invoiceAddress)}
                    onClick={() => {}}
                    noHover
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
};
